<template>
  <div>
    <t-w-loading-spinner v-if="loading" />
    <template v-else>
      <div v-if="userHasMfa && userMfaVerified" data-test="user-mfa">
        <div class="mb-4">
          <label class="mb-2 block">{{ $t('mfa.twoFactorAuthentication') }}</label>
          <user-mfa-enabled-via :type="mfa.type"></user-mfa-enabled-via>
          <button
              type="button"
              class="tw-button tw-button-cta mb-1.5 mr-2 w-full sm:w-auto"
              @click="resetMfaForUser"
              id="reset-mfa-button"
              data-ec="manage_users_two_factor_authentication"
              data-et="btn_reset_mfa">
            <span>{{ $t('mfa.resetMfa') }}</span>
          </button>
        </div>
        <div class="mb-4">
          <label class="mb-2 block">{{ $t('mfa.mfaRecoveryCode') }}</label>
          <recovery-code :code="recoveryCode" />
          <button
              v-if="! recoveryCode"
              type="button"
              class="tw-button tw-button-cta mb-1.5 mr-2 w-full sm:w-auto"
              @click="createRecoveryCode"
              id="create-mfa-recovery-code-button"
              data-ec="manage_users_two_factor_authentication"
              data-et="btn_create_recovery_code"
              data-test="create-recovery-code"
          >
            <span>{{ $t('mfa.generateRecoveryCode') }}</span>
          </button>
        </div>
      </div>
      <template v-else>
        <div class="mb-4" data-test="user-mfa-not-setup">
          <label class="mb-2 block">{{ $t('mfa.twoFactorAuthentication') }}</label>
          <p>{{ $t('mfa.thisUserDoesNotHaveTwoFactorAuthenticationSetup') }}.</p>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import TWLoadingSpinner from '@/components/tailwind/LoadingSpinner.vue';
import { isEmpty } from 'lodash';
import RecoveryCode from '@/components/tailwind/authentication/RecoveryCode.vue';
import { mapActions } from 'vuex';
import UserMfaEnabledVia from '@/components/UserMfaEnabledVia.vue';
import { logAmplitudeEvent } from '@/utils/analytics';

export default {
  name: 'UserMfa',
  components: { UserMfaEnabledVia, RecoveryCode, TWLoadingSpinner },
  props: {
    user: {
      type: Object,
    },
  },

  created() {
    this.getUserMfa();
  },

  data() {
    return {
      recoveryCode: null,
      mfa: {},
      loading: false,
    };
  },

  computed: {
    userHasMfa() {
      return !isEmpty(this.mfa);
    },
    userMfaVerified() {
      return !isEmpty(this.mfa) && this.mfa.verified;
    },

  },

  methods: {
    ...mapActions({
      getMfaForUser: 'userMfa/GET_MFA_FOR_USER',
      deleteMfaForUser: 'userMfa/DELETE_MFA_FOR_USER',
      createRecoveryCodeForUser: 'userMfa/CREATE_RECOVERY_CODE_FOR_USER',
    }),
    getUserMfa() {
      this.loading = true;
      this.getMfaForUser(this.user).then((response) => {
        this.mfa = response.data.data;
      }).catch(() => {
        //
      }).finally(() => {
        this.loading = false;
      });
    },
    createRecoveryCode() {
      this.loading = true;
      this.createRecoveryCodeForUser(this.user).then((response) => {
        this.recoveryCode = response.data.code ? response.data.code : response.data.data.code;
        this.$bus.$emit('renderGlobalMessage', ({
          message: this.$t('mfa.recoveryCodeHasBeenCreated'),
          icon: 'check',
          type: 'success',
        }));
        logAmplitudeEvent('manage_users_two_factor_authentication--create_recovery_code_successful');
      }).catch(() => {
        logAmplitudeEvent('manage_users_two_factor_authentication--create_recovery_code_failed');
      }).finally(() => {
        this.loading = false;
      });
    },
    resetMfaForUser() {
      this.loading = true;
      this.deleteMfaForUser(this.user).then(() => {
        this.mfa = null;
        this.$bus.$emit('renderGlobalMessage', ({
          message: this.$t('mfa.theUsersMfaHasBeenReset'),
          icon: 'check',
          type: 'success',
        }));
        logAmplitudeEvent('manage_users_two_factor_authentication--reset_successful');
      }).catch(() => {
        logAmplitudeEvent('manage_users_two_factor_authentication--reset_failed');
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped>

</style>
